export enum HeaderPanel {
  MICRO = 'micro',
  MACRO = 'macro',
}
